const DEV = import.meta.env.DEV;

export const logger = {
  performance<F extends (...args: any[]) => any>(
    func: F,
    name?: string,
  ): ReturnType<F> {
    if (!DEV) return func();

    console.time(name);

    const result = func();

    if (result instanceof Promise) {
      return result.finally(() => {
        console.timeEnd(name);
      }) as ReturnType<F>;
    }

    console.timeEnd(name);

    return result;
  },
};
